export const mappingFromForm = (mapping) =>
  Object.fromEntries(
    mapping.map((m) => {
      const {
        default_value,
        operation,
        target1,
        target2,
        ...options
      } = m.mapping;
      return [
        m.name,
        {
          default_value: default_value,
          operation: operation,
          options,
          targets: [target1, target2].filter(Boolean),
        },
      ];
    })
  );
